import React, { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './folders_toast.module.scss';

type FolderToastProps = LinkProps;

export const FoldersToastDecisionAdded: FC<FolderToastProps> = ({
  children,
  ...props
}) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/1"
      values={{
        link: (
          <Link {...props} className={styles.link}>
            {children}
          </Link>
        ),
      }}
    />
  </p>
);

export const FoldersToastDecisionRemoved: FC<FolderToastProps> = ({
  children,
  ...props
}) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/2"
      values={{
        link: (
          <Link {...props} className={styles.link}>
            {children}
          </Link>
        ),
      }}
    />
  </p>
);

export const FoldersToastFolderCreated: FC<FolderToastProps> = ({
  children,
  ...props
}) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/3"
      values={{
        link: (
          <Link {...props} className={styles.link}>
            {children}
          </Link>
        ),
      }}
    />
  </p>
);

export const FoldersToastFolderAlreadyAdded: FC<FolderToastProps> = ({
  children,
  ...props
}) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/5"
      values={{
        link: (
          <Link {...props} className={styles.link}>
            {children}
          </Link>
        ),
      }}
    />
  </p>
);
